import React from 'react';
import { Box, FormControl, IconButton, InputLabel, MenuItem, Select } from '@mui/material';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { status } from './featureListHelpers';

// COMPONENT
function FeatureListFilterByStatus({ selectedStatusId, setSelectedStatusId }) {
  const handleClearClick = () => {
    setSelectedStatusId(0);
  };

  return (
    <Box display="flex" flexDirection="row" alignItems="center" marginRight="10px">
      <FormControl sx={{ width: '300px' }}>
        <InputLabel>Filtrar por status</InputLabel>
        <Select
          value={selectedStatusId ?? 0}
          onChange={(e) => {
            setSelectedStatusId(+e.target.value);
          }}
          label="Filtrar por status"
          endAdornment={
            selectedStatusId >= 0 && (
              <IconButton onClick={handleClearClick} sx={{ mr: 1 }}>
                <FontAwesomeIcon icon="times" />
              </IconButton>
            )
          }
        >
          {Object.keys(status).map((key) => (
            <MenuItem value={key} key={key}>
              {status[key].name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}

export default FeatureListFilterByStatus;
